'use client';
'use strict';

var React = require('react');
var core = require('@mantine/core');
var LevelsGroup_module = require('./LevelsGroup.module.css.cjs');

const defaultProps = {};
const LevelsGroup = core.factory((_props, ref) => {
  const props = core.useProps("LevelsGroup", defaultProps, _props);
  const { classNames, className, style, styles, unstyled, vars, __staticSelector, ...others } = props;
  const getStyles = core.useStyles({
    name: __staticSelector || "LevelsGroup",
    classes: LevelsGroup_module,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */ React.createElement(core.Box, { ref, ...getStyles("levelsGroup"), ...others });
});
LevelsGroup.classes = LevelsGroup_module;
LevelsGroup.displayName = "@mantine/dates/LevelsGroup";

exports.LevelsGroup = LevelsGroup;
//# sourceMappingURL=LevelsGroup.cjs.map
